import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2063Status: 'idle',
    startProcess2063Error: undefined as any,
    loadUserParamsProcess2063Status: 'idle',
    loadUserParamsProcess2063Error: undefined as any,

    process2063List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2063 = createAsyncThunk('process2063Slice/startProcess2063', async ({ process2063 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2063/`,
        prepareData(process2063),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2063Status } = getState().process2063Slice
        return startProcess2063Status !== 'pending'
    }
})

export const loadUserParamsProcess2063 = createAsyncThunk('process2063Slice/loadUserParamsProcess2063', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2063/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2063Status } = getState().process2063Slice
        return loadUserParamsProcess2063Status !== 'pending'
    }
})

const Process2063Slice = createSlice({
    name: 'process2063Slice',
    initialState,
    reducers: {
        resetstartProcess2063: (state) => {
            state.job = undefined
            state.startProcess2063Error = undefined
        },
        resetstartProcess2063Error: (state) => {
            state.startProcess2063Error = undefined
        },
        resetloadUserParamsProcess2063: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2063Error = undefined
        },
        resetloadUserParamsProcess2063Error: (state) => {
            state.loadUserParamsProcess2063Error = undefined
        },
        removeFromProcess2063ListById: (state, action) => {
            state.process2063List = state.process2063List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2063ListByIds: (state, action) => {
            state.process2063List = state.process2063List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2063List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2063Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2063List = []
            state.startProcess2063Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2063.pending, (state) => {
            state.startProcess2063Status = 'pending'
            state.startProcess2063Error = undefined
        })
        builder.addCase(startProcess2063.fulfilled, (state, action) => {
            state.startProcess2063Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2063.rejected, (state, action) => {
            state.startProcess2063Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2063Error = action.error.message
            } else {
                state.startProcess2063Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2063.pending, (state) => {
            state.loadUserParamsProcess2063Status = 'pending'
            state.loadUserParamsProcess2063Error = undefined
        })
        builder.addCase(loadUserParamsProcess2063.fulfilled, (state, action) => {
            state.loadUserParamsProcess2063Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2063.rejected, (state, action) => {
            state.loadUserParamsProcess2063Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2063Error = action.error.message
            } else {
                state.loadUserParamsProcess2063Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2063,
    resetstartProcess2063Error,
    resetloadUserParamsProcess2063,
    resetloadUserParamsProcess2063Error,
    removeFromProcess2063ListById,
    removeFromProcess2063ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2063Slice.actions
export default Process2063Slice.reducer
